import { useIsMobile } from "@salestrak/ui";
import { useAutomationsEnabled } from "#app/lib/hooks/use-automations-enabled";
import { useAutomationPermissions } from "./use-automation-permissions";

/**
 * Gate for the per-stage "Automate stage" menu entry (board column menu,
 * table stage-group menu) — the shared `AutomateStageMenuItem` owns the
 * action. Gated the same way as the workflow header popover — flag on +
 * create capability — and hidden on mobile, where building would dead-end
 * on the read-only automations surface.
 */
export function useAutomateStage(workflowId: string | null | undefined) {
  const isMobile = useIsMobile();
  const automationsEnabled = useAutomationsEnabled();
  const { canCreate } = useAutomationPermissions();
  return {
    canAutomateStage:
      !isMobile && automationsEnabled && canCreate && !!workflowId,
  } as const;
}
